import styled from 'styled-components';
import Parent from './style';

const Wrapper = styled(Parent.Wrapper)`
${({ theme }) => `
ul{
    margin: 0;
}
li {
    border-bottom: 0 !important;
    .uploadSection{
        font-size: ${theme.palette.titleLabel} !important;
        align-self: center;
        padding-bottom: 0;
        font-size: 12px;
        color: #C92100;
    }
    .iconContainer {
        align-items: center;
        .MuiAvatar-root {
            width: 27px;
            height: 27px;
        }
    }
    .imageUploadsectionsp {
        display: none;
    }
    .downloadImage{
        font-size: 12px;
        color: #343E48;
        align-items: center;
    }
    .uploadSection + .MuiFormLabel-root{
        font-size: 12px !important;
        color: #222 !important;
        align-self: center;
        padding-bottom: 0;
    }
}
li:nth-child(even):hover,
li:nth-child(even) {
    background: #efefef;
}
`}
`;
const UpdateWrapper = styled(Parent.UpdateWrapper)`
${({ theme }) => `
.uploadSection,
.details {
    font-size: 12px !important;
}
.details {
   color: #222 !important;
}
.uploadDetails {
    font-size: 12px !important;
    color: #6d6d6d !important;
}
`}
`;
const ItemUrl = styled(Parent.ItemUrl)`

`;

const Styled = { Wrapper, UpdateWrapper, ItemUrl };
export default Styled;
